<div class="content-wrapper" fxLayout="column" fxLayoutGap="10px">
  <h4>Forgot Password</h4>

  <form [formGroup]="forgotPasswordForm" (ngSubmit)="submit()">
    <div *ngIf="showLibraryLookupBox">
      <mat-form-field *ngIf="!singleLibrary; else singleLid" fxFlex="100">
        <mat-label>Select Your Library</mat-label>
        <input
          #libraryInput
          matInput
          type="text"
          placeholder="Select Your Library"
          [matAutocomplete]="auto"
          formControlName="lid"
          (focus)="onInputFocus()"
        />
        <button mat-icon-button matSuffix type="button" (click)="clearLibraryInput()">
          <mat-icon>{{ librariesControl.value ? 'clear' : 'keyboard_arrow_down' }}</mat-icon>
        </button>
        <mat-autocomplete
          #auto="matAutocomplete"
          autoActiveFirstOption
          autoSelectActiveOption
          (optionSelected)="onLibraryOptionSelected($event)"
        >
          <mat-option *ngFor="let option of filteredLibraryOptions | async" [value]="option">
            {{ option }}
          </mat-option>
        </mat-autocomplete>

        <mat-error *ngIf="librariesControl.invalid && !librariesControl.pristine"
          >Please select a valid library</mat-error
        >
      </mat-form-field>

      <ng-template #singleLid>
        <mat-form-field fxFlex="100">
          <mat-label>Your Library</mat-label>
          <input matInput type="text" readonly formControlName="lid" />
        </mat-form-field>
      </ng-template>
    </div>

    <div class="form-group">
      <input
        type="text"
        title="User Name"
        class="form-control"
        [placeholder]="userNameLabel"
        id="userName"
        formControlName="userName"
        cdkFocusInitial
        #user
      />
    </div>
    <button
      mat-button
      role="button"
      type="submit"
      aria-label="Submit"
      class="ag-mat-button-primary margin-right-5"
      [disabled]="forgotPasswordForm.invalid"
    >
      Send
    </button>
    <button role="button" aria-label="Cancel" type="button" class="btn btn-link" (click)="cancel()">
      Cancel
    </button>
  </form>
</div>
